import { Text } from "@volca/ui/components/ui/text";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";

export const ProductBenefits = ({ product }: { product: MarketingProduct }) => (
  <ul className="grid gap-5">
    {PRODUCT_MARKETING[product].benefits.map(({ title, description }) => (
      <li key={title}>
        <Text variant="label">{title}</Text>
        <Text tone="muted" className="mt-1 leading-relaxed text-pretty">
          {description}
        </Text>
      </li>
    ))}
  </ul>
);
